import React from "react";
import { useWizard } from "react-use-wizard";
import { Button } from "../../../Actions";
import { StepContent } from "../Components";

const Intro: React.FC = () => {
  const { nextStep } = useWizard();
  return (
    <StepContent
      title="Before you mint, we’re asking all Network members to participate in a
        trust experiment."
      description={
        <>
          We’re building the Network by invitation only. The outcome of your
          trust experiment will determine the number of invitations you receive.
          <br></br>
          <br></br>
          It will only take a couple minutes. If you’re busy, you can exit now
          and return at any time. Your phrase is valid until you mint.
        </>
      }>
      <Button
        analyticsProperty="Begin Game"
        modifier="primary"
        onClick={() => nextStep()}>
        Begin
      </Button>
    </StepContent>
  );
};

export default Intro;
